import { ModelMenu } from "./ModelMenu";
import { Json } from "./../../libs/Json";
import { modules } from "../../main";
import { HTMLController } from "./../../classes/mvc/HTML/HTMLController";
import { Arrays } from "./../../libs/Arrays";
import { Globals } from "../../classes/Globals";
import { Logging } from "../../classes/logging/Logging";
import { Modules } from "../../Modules";

declare let ezentrum_variables:any;
declare let ezentrum_session_vars: any;

export class ControllerMenu extends HTMLController<ModelMenu> {

	private static MENU_FILE: Object;
	private static FULL_SEO_LINK: string;
	// data-configurations
	private position: string; // data-ez-param-pos=[main_navi|header_navi|footer_navi]
	private templatename: string;   // data-ez-param-template=[side_nav|header_navi]
	private template: Object;  // YAML-Datei: modules/Menu/components/foundation/template/$this.templatename --> assign the template for the menu from the YAML-File to process. (Template consists of the following nodes: container, rows)
	private fallback: string; // TODO: Check if we need this option any more.
	private entryPoint: string; // TODO: Check if we need this option any more.
	private baseLinkPath: string;
	private useAllItems: boolean; // data-ez-param-use-all=["true"|"false"]
	private isInSideNav: boolean = false;
	private isInMainNav: boolean = false;
	private isInHeaderNav: boolean = false;
	private zartmode: boolean = false; // data-ez-param-zartmode=["true"|"false"]

	// Global YAML Configurations
	private menuFileBasePath: string; // Menu-File-Basepath is the base-path for the menu.json file to load. YAML-Location: /modules/menu/config/root_folder

	public constructor ( accessName: string, accessID: number, element: JQuery<HTMLElement> ){
		super( new ModelMenu(), accessName, accessID, element );
	}

	// method: initGlobals
	// Global init method.
	// 1. Set Full-SEO-Link
	// 2. Sets the url-location for the menu-json-file

	public initGlobals ():void{
		if ( Modules.isInShopView ) {
			ControllerMenu.FULL_SEO_LINK = ezentrum_variables.full_seo_link;
		} else {
			if ( Modules.modulesVariables.hasOwnProperty("required") ) {
				ControllerMenu.FULL_SEO_LINK = Modules.modulesVariables.sb.full_seo_link;
			}
		}
		
		let rootFolder = this.getModule().getConfig("root_folder");
		rootFolder = ( rootFolder == null ? "": rootFolder );

		// Build the menu file base path
		this.menuFileBasePath = window.location.origin;
		if ( rootFolder != "" ){
			this.menuFileBasePath += "/" + rootFolder; // test.domain.de/rootFolder/menu-de.json
		} else {
			this.menuFileBasePath += "/menu"; // URL: test.domain.de/menu/menu-de.json
		}
		this.menuFileBasePath += "/menu-";
		// Get the menu file
		ControllerMenu.MENU_FILE = this.getModel().getMenuFile( this.menuFileBasePath );
    }

	/*
		Example: HTML-Tag for the navigation
		Parameters: 
		
		- data-ez-param-template=[side_nav|header_navi] : Configuration HTML-Template in the yaml configuration. Please check your yaml-configuration.
			- option "side_nav" : YAML-Defintion for the side-navigation.
			- option "header_navi" : YAML-Defintion the the header-navigation.

		- data-ez-module-menu="" : [""] Empty value. Mandatory for initialize the navigation. Without this data-parameter the navigation will not be rendered.
		
		- data-ez-param-pos=[main_navi|header_navi|footer_navi]
			- option "main_navi" : Rendering only main navigation elements from the navigtion definition (External Links and all other not main elements will not be inculded)
			- option "header_navi" : Rendering of the header navigation. It includes all navigation-entries where the positions are set to "header_navi".
			- option "footer_navi" : Rendering ot the footer navigation. It includes all navigation-entires where the positions are seth the "footer_navi".

			- Example-Navigation-Node (head-node in the menu.json -> positions array defines the visibilty of the node. To render a header-navi them data-paramenter for the html-element needs to be set to data-ez-param-pos="header_navi" )
				"head": {
					"level": 1,
					"position": 1,
					"article_count": 0,
					"parent_article_count": 0,
					"positions": [
						"header_navi",
						"footer_navi"
					]
				}
				
		- data-ez-param-use-all=["true"|"false"]
			option : "true" -> renders all nodes, even if sub-elements have no-hit entries
			option : "false" -> renders only nodes this hits>0. Be carefull when you will active this mode, because if all sub-elements have 0 hits, the main node will not be display.

		- data-ez-param-zartmode=["true"|"false"]
			option : "true" -> renders navigation in with zartmode
			option : "false" -> renders navigation without zartmode


		Example: Header-Navigation-HTML-Element
		------------------------------------------
		<div id="navi-2" data-ez-module-menu="" data-ez-param-pos="header_navi" data-ez-param-template="header_navi" data-ez-param-use-all="true">
			<ul data-ez-output></ul>
		</div>

		Example: Main-Side-Navigation-HTML-Element
		------------------------------------------
		<div id="navi-2" data-ez-module-menu="" data-ez-param-pos="main_navi" data-ez-param-template="side_nav" data-ez-param-use-all="true">
			<ul data-ez-output></ul>
		</div>

	*/

	public run ():void{
		if ( ControllerMenu.MENU_FILE != null ) { // Is a menu-json-file defined?
			// Get the defined template for the menu from html-data-attributes
			this.templatename = this.getParam( "template" );

			switch( this.templatename ) {
				case "side_nav":
					this.isInSideNav = true;
					break;
				case "main_nav":
					this.isInMainNav = true;
					break;
				case "header_nav":
					this.isInHeaderNav = true;
					break;
			}

			if ( this.templatename !== null ) {

				// load all configurations for the menu from data-attributes + yaml setup
				this.template = this.getModule().getComponent( "templates." + this.templatename );
				this.position = this.getParam( "pos" );
				this.fallback = this.getParam( "fallback" ); //TODO: Check if fallback will be needed anymore
				this.entryPoint = this.getParam( "entry" ); // TODO: Check if we need this option any more.
				this.baseLinkPath = "";
				this.useAllItems = this.getParam( "use-all" ) == "true"; 
				this.zartmode = this.getParam( "zartmode" ) == "true"; 

				if ( this.position == null ) this.position = "";
				if ( this.fallback == null ) this.fallback = ""; 
				if ( this.entryPoint == null ) this.entryPoint = ""; 
				if ( this.useAllItems == null ) this.useAllItems = false;
				if ( this.zartmode == null ) this.zartmode = false;

				if ( typeof ControllerMenu.FULL_SEO_LINK !== "undefined" ) {
					if ( this.template != null ) {
						//Set the entry point
						let items:Array<Object> = Json.getSubobject( ControllerMenu.MENU_FILE, "elements" );
						if ( this.entryPoint != "" ) {
							let entry:Array<Object> = this.findEntryPoint( items, this.entryPoint );
							if( entry != null ){
								this.baseLinkPath = this.entryPoint;
								items = entry;
							}
						}
						// Start processing
						this.outputElements( this.processAll( items ) );
						// Anpassungen nach der Erstellung des HTML
						if (this.getModule().getConfig("hasMouseOverEvent") && this.isInHeaderNav) {
							// this.mouseOverEvent();
							this.mouseOverEvent_v2();
						}
					} else {
						this.getModule().error( Globals.MODULE_LOADING_ERROR + " das folgende Template nicht gefunden wurde: " + this.templatename );
					}
				} else {
					this.getModule().error( Globals.MODULE_LOADING_ERROR + " folgende Variable fehlt: ezentrum_variables.full_seo_link" );
				}
			} else {
				this.getModule().error( Globals.MODULE_LOADING_ERROR + " kein Template angegeben wurde" );
			}
		} else {
			this.getModule().error( Globals.MODULE_LOADING_ERROR + " keine der folgenden Menüdateien geladen werden konnte: " + this.menuFileBasePath + "[sprachID z.B 1].json oder" + this.menuFileBasePath + "[sprachCode z.B. de].json" );
		}
	}

	/**
	 * @description Handling of the dropdowns content for hover, css doesn't work for everything apparently...
	 */
	private mouseOverEvent():void {
		const ez_header_lv2Elements:NodeListOf<HTMLUListElement> = document.querySelectorAll('.ez_header_lv2:not(.ez_first_item)');

		if (ez_header_lv2Elements instanceof NodeList) {
			ez_header_lv2Elements.forEach( element => {
				element.addEventListener('mouseover', ()=> {
					const ez_first_header_lv2Element:HTMLUListElement = element.parentElement.querySelector('.ez_first_item').lastElementChild as HTMLUListElement;
					if (ez_first_header_lv2Element.classList.contains('d-flex')) {
						ez_first_header_lv2Element.classList.remove('d-flex');
					}
					! ez_first_header_lv2Element.classList.contains('d-none') ? ez_first_header_lv2Element.classList.add('d-none') : null;
				});
				element.addEventListener('mouseout', ()=> {
					const ez_first_header_lv2Element:HTMLUListElement =  element.parentElement.querySelector('.ez_first_item').lastElementChild as HTMLUListElement;
					if (ez_first_header_lv2Element.classList.contains('d-none')) {
						ez_first_header_lv2Element.classList.remove('d-none');
					}
					! ez_first_header_lv2Element.classList.contains('d-flex') ? ez_first_header_lv2Element.classList.add('d-flex') : null;
				});
			});
		}
	}

	private mouseOverEvent_v2():void {

		const shopName: string = this.getModule().getConfig("shopName");
		if ( shopName ) {
			switch(shopName) {
				case 'riegelb2c':
					let headerNaviList = document.querySelectorAll('[data-ez-has-sub-elements]');
					const header2Container = document.getElementById('header_2_container');
					const contentWrap = document.getElementById('content_wrap');
					if ( headerNaviList.length <= 0 || !contentWrap || !header2Container ) return null;
					headerNaviList = document.querySelectorAll('[data-ez-has-sub-elements]');
					headerNaviList.forEach( ele => {
						ele.addEventListener('mouseover', ()=> {
							header2Container.style.height = '353.280px';
							header2Container.style.transition = 'height 0.5s ease 0s';

							contentWrap.style.marginTop = '248.289px';
							contentWrap.style.transition = 'margin-top 0.5s ease 0s';
						});
					});
					headerNaviList.forEach( ele => {
						ele.addEventListener('mouseout', ()=> {
							header2Container.style.height = '105px';
							header2Container.style.transition = 'height 0.5s ease 0.1s';

							contentWrap.style.marginTop = '0';
							contentWrap.style.transition = 'margin-top 0.5s ease 0.1s';
						});
					});
				break;
				default: break;
			}
			return;
		}

		// OLD from Supplementa 2023 (ww3), aboth is new / better for handling different shops
		const ez_header_hover_container:NodeListOf<HTMLElement> = document.querySelectorAll('.ez_header_left_bar');
		if ( ez_header_hover_container.length <= 0 ) return;

		ez_header_hover_container.forEach( hoverContainer => {
			const ezHeaderContainerHoverableElements = hoverContainer.querySelectorAll('.ez_header_lv2');
			if ( ezHeaderContainerHoverableElements.length <= 0 ) return;

			// element.querySelector('.ez_right_sublevel')
			ezHeaderContainerHoverableElements[0].querySelector('.ez_right_sublevel')?.classList.add('ez_hoverable_element');
			// listener on the container
			hoverContainer.addEventListener('mouseover', ( event )=> {
				// checking which element has been hovered
				ezHeaderContainerHoverableElements.forEach( ( hoverElement )=> {
					if ( hoverElement !== event.target ) return;
					// enabling the hovered elements content
					if (hoverElement.querySelector('.ez_right_sublevel'))
						hoverElement.querySelector('.ez_right_sublevel').classList.add('ez_hoverable_element');
					// disabling all other contents
					ezHeaderContainerHoverableElements.forEach( ( elements, position) => {
						if ( elements !== event.target && ezHeaderContainerHoverableElements[position]?.querySelector('.ez_right_sublevel')?.classList.contains('ez_hoverable_element'))
						ezHeaderContainerHoverableElements[position].querySelector('.ez_right_sublevel').classList.remove('ez_hoverable_element');
					});
				});
			});
		});
	}

	private findEntryPoint( items:Array<Object>, path:string ): Array<Object>{
		let result: Array<Object> = null;
		let pathItems: Array<string> = path.split( "/" );
		for (let i = 0; i < pathItems.length; i++) {
			for (let j = 0; j < items.length; j++) {
				if( Json.getSubobject( items[j], "body.link" ) == pathItems[i] ){
					if( i == pathItems.length - 1 ){
						result = Json.getSubobject( items[j], "sub_elements" );
					} else {
						result = this.findEntryPoint( Json.getSubobject( items[j], "sub_elements" ), Arrays.removeByIndex( pathItems, i ).join("/") );
					}
					break;
				}
			}
			break;
		}
		return result;	
	}

	// Method: outputElements
	// Generates from one html-element for the resulting html-string
	private outputElements ( content:string ):void{
		let element:JQuery<HTMLElement> = content != "" ? jQuery( content ) : jQuery( this.fallback );
		if( element.length ){
			if ( !this.setOutputElement( element ) ){
				this.getElement().append( element );

			}
		}
	}
	
	// Method: processAll
	// Central method processes the entries of each level
	private processAll ( elements:Array<Object> ):string{
		let result = null
		if ( elements != null ) {
			this.getModule().addView( "main_container", Json.getSubobject( this.template, "main_container" ) ) 
			result = this.processOne( "main_container", "elements", this.processLevel( elements ) );
			this.getModule().clearViews();
		}
		return result;
	}

	// Method: processLevel
	// Central method processes the entries of each level
	private processLevel ( elements:Array<Object>, lastlink:string = "", is_subelement:boolean = false ):string{
		let result:string = "";
		if ( elements != null ) {

			// Loop through the items
			for (let i = 0; i < elements.length; i++) {
				let modelID = this.getModel().new();
				let last_link = lastlink;
				if ( !is_subelement ) { last_link = ""; }
				let element = elements[i];
				let allowed_positions:Array<string> = Json.getSubobject( element, "head.positions" );

				if ((allowed_positions.indexOf( this.position ) >= 0) || (this.useAllItems))
				{
					// Local Processing Vars
					let currentFullLink:string = "";
					let current_template:string = "";
					let level:number = Json.getSubobject( element, "head.level" );
					let sbid:number = Json.getSubobject( element, "body.sbid" );
					let link:string = Json.getSubobject( element, "body.link" );
					let all_subelements:Array<Object> = Json.getSubobject( element, "sub_elements" );
					let allowed_subelements:Array<Object> = new Array(); // Array of allowed navigation-sub-element items
					let display_node_without_hits:boolean=false; // ZART-Mode Display without hits status
					if (sbid===12662)
						console.log("Hello");

					let sumOfAllArtsInSubmenu:number=0;
					if( this.useAllItems ) // Process all entries from level 1, ignore if sub-elements have 0 positions. 
					{
						if (this.zartmode) // Check display sub-elements 
						{
							if (level===1) // Level 1 processing -> Up to Level-4
							{
								// Processing Sub-Elements Level-1 - Calculate sumOfAllArtsinSubment
								for (let j = 0; j < all_subelements.length; j++) {
									let subelementBody:any=all_subelements[j];
									let numberSubmenuArts:number=subelementBody.head.article_count;
									let numverZartVisibleArts:number=this.countVisibleZartNumberArts(subelementBody.body.sbid,numberSubmenuArts);
									sumOfAllArtsInSubmenu=sumOfAllArtsInSubmenu+numverZartVisibleArts; // ZART Minus ggfs. plus
								}
								// Processing Sub-Elements Level 2
								for (let j = 0; j < all_subelements.length; j++) {
									let subelementBody:any=all_subelements[j];
									let display:boolean=this.checkDisplayStatus(subelementBody.body.sbid, 2,sumOfAllArtsInSubmenu); // Central Method for display checking. Implementation "display" in YAML configuration.
									if ( display){
										allowed_subelements.push( subelementBody );
										display_node_without_hits=true;
									} else {
										// Level-3: Processing Sub-Elements Calculation sumOfAllArtsInSubmenu3
										let all_subelements_level3:Array<Object> = Json.getSubobject( subelementBody, "sub_elements" );
										let sumOfAllArtsInSubmenu3:number=0;
										// Processing Sub-Elements Level-3 - Calculate sumOfAllArtsinSubment
										for (let j = 0; j < all_subelements_level3.length; j++) {
											let subelementBodyLevel3:any=all_subelements_level3[j];
											let numberSubmenuArts:number=subelementBodyLevel3.head.article_count;
											let numverZartVisibleArts:number=this.countVisibleZartNumberArts(subelementBodyLevel3.body.sbid,numberSubmenuArts);
											sumOfAllArtsInSubmenu3=sumOfAllArtsInSubmenu3+numverZartVisibleArts; // ZART Minus ggfs. plus
										}
										// Processing Level-3 Submenus
										for (let j = 0; j < all_subelements_level3.length; j++) {
											let subelementBodyLevel3:any=all_subelements_level3[j];
											let display3:boolean=this.checkDisplayStatus(subelementBodyLevel3.body.sbid, 3,sumOfAllArtsInSubmenu3); // Central Method for display checking. Implementation "display" in YAML configuration.
											if ( display3){
												display_node_without_hits=true;
											}else
											{
												// Processing Level-4 Submenus
												let all_subelements_level4:Array<Object> = Json.getSubobject( subelementBodyLevel3, "sub_elements" );
												let sumOfAllArtsInSubmenu4:number=0;
												// Processing Sub-Elements Level-4 - Calculate sumOfAllArtsinSubelement
												for (let p = 0; p < all_subelements_level4.length; p++) {
													let subelementBodyLevel4:any=all_subelements_level4[p];
													let numberSubmenuArts:number=subelementBodyLevel4.head.article_count;
													let numverZartVisibleArts:number=this.countVisibleZartNumberArts(subelementBodyLevel4.body.sbid,numberSubmenuArts);
													sumOfAllArtsInSubmenu4=sumOfAllArtsInSubmenu4+numverZartVisibleArts;
												}
												for (let p = 0; p < all_subelements_level4.length; p++) {
													let subelementBodyLevel4:any=all_subelements_level4[p];
													let display4:boolean=this.checkDisplayStatus(subelementBodyLevel4.body.sbid, 4,sumOfAllArtsInSubmenu4); // Central Method for display checking. Implementation "display" in YAML configuration.
													if ( display4){
														display_node_without_hits=true;
													}
												}
											}
										}

										if (display_node_without_hits) // If the zartmode is active, then main nodes without no hits, will be displayed, if a sub-child will be displayed in zartmode, even if the number for general articles is per default 0, the zartmode will add them dynamically.
										{
											allowed_subelements.push( subelementBody );
										}
									}
								}
							}
							else // > Level 1 processing
							{
								// Level: 2 --> Then check up to level 4
								if (level==2)
								{
									// Level 3 : Processing Sub-Elements
									let sumOfAllArtsInSubmenu3:number=0;
									for (let j = 0; j < all_subelements.length; j++) {
										let subelementBody:any=all_subelements[j];
										let numberSubmenuArts3:number=subelementBody.head.article_count;
										let numverZartVisibleArts:number=this.countVisibleZartNumberArts(subelementBody.body.sbid,numberSubmenuArts3);
										sumOfAllArtsInSubmenu3=sumOfAllArtsInSubmenu3+numverZartVisibleArts;
									}

									// Level 3 : Processing
									for (let j = 0; j < all_subelements.length; j++) {
										let subelementBody:any=all_subelements[j];
										let display3:boolean=this.checkDisplayStatus(subelementBody.body.sbid, 3,sumOfAllArtsInSubmenu3); // Central Method for display checking. Implementation "display" in YAML configuration.
										if ( display3){
											allowed_subelements.push( all_subelements[j] );
											display_node_without_hits=true;
										}

										// Level 4 : Processing
										if (display_node_without_hits===false)
										{
											// Level 4 : Processing Sub-Elements
											let all_subelements_level4:Array<Object> = Json.getSubobject( subelementBody, "sub_elements" );
											let sumOfAllArtsInSubmenu4:number=0;
											for (let p = 0; p < all_subelements_level4.length; p++) {
												let subelementBodyL4:any=all_subelements_level4[p];
												let numberSubmenuArts4:number=subelementBodyL4.head.article_count;
												let numverZartVisibleArts:number=this.countVisibleZartNumberArts(subelementBodyL4.body.sbid,numberSubmenuArts4);
												sumOfAllArtsInSubmenu4=sumOfAllArtsInSubmenu4+numverZartVisibleArts;
											}

											for (let p = 0; p < all_subelements_level4.length; p++) {
												let subelementBodyL4:any=all_subelements_level4[p];
												let display:boolean=this.checkDisplayStatus(subelementBodyL4.body.sbid, 4,sumOfAllArtsInSubmenu4); // Central Method for display checking. Implementation "display" in YAML configuration.
												if ( display){
													allowed_subelements.push( all_subelements[j] );
													display_node_without_hits=true;
												}
											}
										}
									}

								}
								else // Process Level 3 -> Check Level 4
								{
									for (let j = 0; j < all_subelements.length; j++) {
										let subelementBody:any=all_subelements[j];
										let checkSBID=subelementBody.body.sbid;
										let numberSubmenuArts:number=subelementBody.head.article_count;
										let numverZartVisibleArts:number=this.countVisibleZartNumberArts(checkSBID,numberSubmenuArts);
										sumOfAllArtsInSubmenu=sumOfAllArtsInSubmenu+numverZartVisibleArts;
									}
									// Level 4
									for (let j = 0; j < all_subelements.length; j++) {
										let subelementBody:any=all_subelements[j];
										let display:boolean=this.checkDisplayStatus(subelementBody.body.sbid, level+1,sumOfAllArtsInSubmenu); // Central Method for display checking. Implementation "display" in YAML configuration.
										if ( display){
											allowed_subelements.push( all_subelements[j] );
											display_node_without_hits=true;
										}
									}
								}
							}
						}
						else if (this.isSpeaMode())
						{
							sumOfAllArtsInSubmenu=0;
							if (level===1) // Level 1 processing -> Up to Level-4
							{
								sumOfAllArtsInSubmenu=this.getArticleSumOfLevelElements(all_subelements);
								// Processing Level-2 
								for (let j = 0; j < all_subelements.length; j++) {
									let subelementBody:any=all_subelements[j];
									let display:boolean=this.checkDisplayStatus(subelementBody.body.sbid, 2,sumOfAllArtsInSubmenu); // Central Method for display checking. Implementation "display" in YAML configuration.
									if ( display){
										allowed_subelements.push( subelementBody );
										display_node_without_hits=true;
									} else {
										
										// Level-3: Processing Sub-Elements Calculation sumOfAllArtsInSubmenu3
										let all_subelements_level3:Array<Object> = Json.getSubobject( subelementBody, "sub_elements" );
										// Level-3: Calculate sumOfAllArtsinSubelement
										let sumOfAllArtsInSubmenu3:number=this.getArticleSumOfLevelElements(all_subelements_level3);
										
										// Processing Level-3 Submenus
										for (let j = 0; j < all_subelements_level3.length; j++) {
											let subelementBodyLevel3:any=all_subelements_level3[j];
											let display3:boolean=this.checkDisplayStatus(subelementBodyLevel3.body.sbid, 3,sumOfAllArtsInSubmenu3); // Central Method for display checking. Implementation "display" in YAML configuration.
											if ( display3){
												display_node_without_hits=true;
											}else
											{
												
												// Level-4: Processing Submenus
												let all_subelements_level4:Array<Object> = Json.getSubobject( subelementBodyLevel3, "sub_elements" );
												// Level-4: Calculate sumOfAllArtsinSubelement
												let sumOfAllArtsInSubmenu4:number=this.getArticleSumOfLevelElements(all_subelements_level4);

												for (let p = 0; p < all_subelements_level4.length; p++) {
													let subelementBodyLevel4:any=all_subelements_level4[p];
													let display4:boolean=this.checkDisplayStatus(subelementBodyLevel4.body.sbid, 4,sumOfAllArtsInSubmenu4); // Central Method for display checking. Implementation "display" in YAML configuration.
													if ( display4){
														display_node_without_hits=true;
													}
												}
											}
										}

										if (display_node_without_hits) // If the spea-mode is active, then main nodes without no hits, will be displayed, if a sub-child will be displayed in spea-mode, even if the number for general articles is per default 0, the spea-mode will add them dynamically.
										{
											allowed_subelements.push( subelementBody );
										}
									}
								}


							}else if (level===2) // Level 2 processing -> Up to Level-4
							{
								// Level 3 : Processing Sub-Elements
								let sumOfAllArtsInSubmenu3:number=this.getArticleSumOfLevelElements(all_subelements);
								// Level 3 : Processing
								for (let j = 0; j < all_subelements.length; j++) {
									let subelementBody:any=all_subelements[j];
									let display3:boolean=this.checkDisplayStatus(subelementBody.body.sbid, 3,sumOfAllArtsInSubmenu3); // Central Method for display checking. Implementation "display" in YAML configuration.
									if ( display3){
										allowed_subelements.push( all_subelements[j] );
										display_node_without_hits=true;
									}

									// Level 4 : Processing
									if (display_node_without_hits===false)
									{
										// Level 4 : Processing Sub-Elements
										let all_subelements_level4:Array<Object> = Json.getSubobject( subelementBody, "sub_elements" );
										let sumOfAllArtsInSubmenu4:number=this.getArticleSumOfLevelElements(all_subelements_level4);
										
										for (let p = 0; p < all_subelements_level4.length; p++) {
											let subelementBodyL4:any=all_subelements_level4[p];
											let display:boolean=this.checkDisplayStatus(subelementBodyL4.body.sbid, 4,sumOfAllArtsInSubmenu4); // Central Method for display checking. Implementation "display" in YAML configuration.
											if ( display){
												allowed_subelements.push( all_subelements[j] );
												display_node_without_hits=true;
											}
										}
									}
								}

							}else if (level===3) // Level 3 processing -> Up to Level-4
							{
								// Level 3 : Processing Sub-Elements
								let sumOfAllArtsInSubmenu4:number=this.getArticleSumOfLevelElements(all_subelements);

								// Level 4
								for (let j = 0; j < all_subelements.length; j++) {
									let subelementBody:any=all_subelements[j];
									let display:boolean=this.checkDisplayStatus(subelementBody.body.sbid, level+1,sumOfAllArtsInSubmenu4); // Central Method for display checking. Implementation "display" in YAML configuration.
									if ( display){
										allowed_subelements.push( all_subelements[j] );
										display_node_without_hits=true;
									}
								}
							}
						}
						else
						{
							allowed_subelements = all_subelements;
							display_node_without_hits=true;
						}
							
					} 
					else  // Process all entries from level 1 and display only entries that have more than 0 entries. 
					{

						// Note: If all entries for the sub-elements have 0 hits, then the main node for example on level-1 will not be displayed.
						// Please consider this for the navigation and if a main node will not be displayed, then please check, whether all sub-items have 0 positions.
						// If you want to display the main entry even if all sub-elements have 0 positions, then activate this.useALLItems.

						// Get all allowed sub items
						for (let j = 0; j < all_subelements.length; j++) {
							let tmp_allowed_positions:Array<string> = Json.getSubobject( all_subelements[j], "head.positions" );
							if ( tmp_allowed_positions.indexOf( this.position ) >= 0 ){
								allowed_subelements.push( all_subelements[j] );
							}
						}

					}

					if ( allowed_subelements.length > 0 ) 	// Process item with sub elements
					{
						last_link += ( last_link == "" ? "" : "/" ) + link;
						let currentContainer:string = Json.getSubobject( this.template, "containers." + level );
						if ( currentContainer != null ){
							current_template = "current_container_" + level;

							this.getModule().addView( current_template, currentContainer );
							this.getModel().add( modelID, "elements", this.processLevel( allowed_subelements, last_link, true ) );
						}
						currentFullLink = last_link;
					} else 
					{
						// Process single item
						 if ((this.zartmode)&&(level===1))
						 {
							 // Do not display level 1 - if no level-2 entries have status display
						 }
						 else
						 {
							let currentRow:string = Json.getSubobject( this.template, "rows." + level );
							if ( currentRow != null ){
								current_template = "current_row_" + level;
								this.getModule().addView( current_template, currentRow );
							}
						}
						currentFullLink = last_link + ( last_link == "" ? "" : "/" ) + link;
					}

					if ( this.baseLinkPath != "" ){
						currentFullLink = this.baseLinkPath + "/" + currentFullLink;
					}

					if ( current_template != "" ) // Is a temmplate defined in the yaml file
					{
						// Check if the current item is active
						let sameValueCount:number = 0;
						let fullSEOLinkItems:Array<string> = ControllerMenu.FULL_SEO_LINK.split( "/" );
						let currentFullLinkItems:Array<string> = currentFullLink.split( "/" );

						for (let j = 0; j < currentFullLinkItems.length; j++) {
							if ( fullSEOLinkItems[j] !== undefined ){
								if ( fullSEOLinkItems[j] == currentFullLinkItems[j] ){
									if (currentFullLinkItems[j]!=="")
										sameValueCount++;
								}
							}
						}

						let active:boolean = (sameValueCount == currentFullLinkItems.length);
						/**
						 * 
						 * All all global items to the model
						 */
						this.getModel().add( modelID, "head", Json.getSubobject( element, "head" ) );
						this.getModel().add( modelID, "body", Json.getSubobject( element, "body" ) );
						this.getModel().add( modelID, "active", active );
						if (sbid===12662)
							console.log("Hello");
						let display:boolean=this.checkDisplayStatus(sbid, level, sumOfAllArtsInSubmenu); // Central Method for display checking. Implementation "display" in YAML configuration.
						if (display_node_without_hits) // Only set in SPEA + ZART Mode - Global State
							display=true;
						this.getModel().add( modelID, "display", display );
						this.getModel().add( modelID, "isInSideNav", this.isInSideNav );
						this.getModel().add( modelID, "isInMainNav", this.isInMainNav );
						this.getModel().add( modelID, "children", allowed_subelements.length );
						this.getModel().add( modelID, "first_item", i == 0);
						this.getModel().add( modelID, "last_item", i == elements.length - 1);
						this.getModel().add( modelID, "count", i);
						this.getModel().add( modelID, "curr_link", ControllerMenu.FULL_SEO_LINK );
						this.getModel().add( modelID, "language", modules.getLanguageCode());

						if ( sbid == 0 ){
							this.getModel().add( modelID, "curr_item_link", link );
						} else {
							this.getModel().add( modelID, "curr_item_link", currentFullLink );
						}

						/**
						 * 
						 * Process Handlebars
						 */
						result += this.process( modelID, current_template, true );
					}
				}
			}

		}

		return result;
	}


	private getArticleSumOfLevelElements(allSubelements:any):number{
		let res:number=0;
		// Processing Sub-Elements Level-1 - Calculate sumOfAllArtsinSubment
		for (let j = 0; j < allSubelements.length; j++) {
			let subelementBody:any=allSubelements[j];
			let numberSubmenuArts:number=subelementBody.head.article_count;
			let numverZartVisibleArts:number=this.countVisibleZartNumberArts(subelementBody.body.sbid,numberSubmenuArts);
			res=res+numverZartVisibleArts; // ZART Minus ggfs. plus
		}
		return res;
	}

	// Method: checkDisplayStatus
	// Processing one entry in the navigation.
	// All elements of the navigation will call this method to check if one navigation entry will be displayed.
	private checkDisplayStatus (sbid:number, level:number, sumOfAllVisibleArtsInSubmenu:number):boolean{
		let result:boolean = true;
		if ((level===1) && (this.zartmode===true))
			return true;
		//if (this.check_display_status===false) 
		//	return true;

		if ( Modules.isInShopView ) {
			if ( ezentrum_session_vars.Navi_Master_SBID===undefined ) return true;
		} else {
			if ( Modules.modulesVariables.Navi_Master_SBID===undefined ) return true;
		}
		
		// Find Navi-Master-SB Entries
		let resMasterSBIDIndex;
		let mandand_spea_mode:boolean;

		if ( Modules.isInShopView ) {
			resMasterSBIDIndex = ezentrum_session_vars.Navi_Master_SBID.findIndex(( entry: any ) => entry === sbid);
			mandand_spea_mode = ezentrum_session_vars.mandant_flag_spea;
		} else {
			resMasterSBIDIndex = Modules.modulesVariables.Navi_Master_SBID.findIndex(( entry: any ) => entry === sbid);
			mandand_spea_mode = Modules.modulesVariables.mandant_flag_spea;
		}
		
		this.log("Navi_Master_SBID-Index:"+resMasterSBIDIndex,"");

		if ( Modules.isInShopView ) {
			this.log( "Navi_Master-SBID-CountEntries:" + ezentrum_session_vars.Navi_Master_SBCount[resMasterSBIDIndex], "" );
		} else {
			this.log( "Navi_Master-SBID-CountEntries:" + Modules.modulesVariables.Navi_Master_SBCount[resMasterSBIDIndex], "");
		}
		
		if (mandand_spea_mode) 	// Find all SPEA-Index-Entries for the SBID
		{
			this.log("checkDisplayStatus: Navi-Spea-Mode: active, Level="+level,"");
			if ( Modules.isInShopView ) {
				this.log("customer-spea-ids: " + ezentrum_session_vars.Customer_SPEASBIDs, "");
			} else {
				this.log( "customer-spea-ids: " + Modules.modulesVariables.Customer_SPEASBIDs, "" );
			}
		
			let resSBIDSpeaMatchIndex=[];
			let resSPEASBCount=[]; // SPEA-SBID-Match-Count Array -> Contains all SPEA-SBIDs-Counts = Hits for the SPEA-SBID-Articles
			let resSPEASBIDs=[]; // SPEA-SBId-Match Array -> Contains all SBIds that matches to the ASSIGENDSBIDs.
			let resSPEAID=[]; // SPEA-ASSIGENDSBIDs-TO-SBID

			let i = -1;
			if ( Modules.isInShopView ) {
				while ((i = ezentrum_session_vars.Navi_SPEA_SBID.indexOf(sbid, i+1)) != -1) {
					resSBIDSpeaMatchIndex.push(i);
				}
			} else {
				while ((i = Modules.modulesVariables.Navi_SPEA_SBID.indexOf(sbid, i+1)) != -1){
					resSBIDSpeaMatchIndex.push(i);
				}
			}
			

			// Loop through the SBID-ZART-Matches and fill up the ZART-Match-Arrays
			for (let i = 0; i < resSBIDSpeaMatchIndex.length; i++) {
				let index=resSBIDSpeaMatchIndex[i];
				if ( Modules.isInShopView ) {
					resSPEASBCount.push(ezentrum_session_vars.Navi_SPEA_COUNT[index]);
					resSPEASBIDs.push(ezentrum_session_vars.Navi_SPEA_SBID[index]);
					resSPEAID.push(ezentrum_session_vars.Navi_SPEA_ID[index]);
				} else {
					resSPEASBCount.push( Modules.modulesVariables.Navi_SPEA_COUNT[index] );
					resSPEASBIDs.push( Modules.modulesVariables.Navi_SPEA_SBID[index] );
					resSPEAID.push( Modules.modulesVariables.Navi_SPEA_ID[index] );
				}
			}

			this.log("SPEA-SBID-Count: "+resSPEASBCount.toString(),"");
			this.log("SPEA-SBID: "+resSPEASBIDs.toString(),"");
			this.log("SPEA-SBID-ASSIGNED-TO-SBID: "+resSPEAID.toString(),"");

			// SPEA SB-Article-Count will replace the original SB-Article-Count for the Navigation
			let isSPEA:boolean=false;
			let speaSBIDCount:number=0;
			for (let p = 0; p < resSPEASBIDs.length; p++) {
				let speaSBID:number=resSPEAID[p]; 
				let findSPEAID:number;

				if ( Modules.isInShopView ) {
					findSPEAID = ezentrum_session_vars.Customer_SPEASBIDs.indexOf(speaSBID);
				} else {
					findSPEAID = Modules.modulesVariables.Customer_SPEASBIDs.indexOf(speaSBID);
				}

				if (findSPEAID>=0)
				{
					isSPEA=true;
					let addSPEAHits:number=resSPEASBCount[p];
					speaSBIDCount+=addSPEAHits;
					this.log("Identified SPEA-SBID-ASSIGNED-TO-SBID: "+speaSBID+"->"+sbid+", Article-Count:"+addSPEAHits,"");
				}
			}

			if (isSPEA===true) // Replace the Navigation-Hits with SPEA-Sum of SPEA-SB-ID-Counts
			{
				let findMasterSBID:number;

				if ( Modules.isInShopView ) {
					findMasterSBID = ezentrum_session_vars.Navi_Master_SBID.indexOf(sbid);
				} else {
					findMasterSBID = Modules.modulesVariables.Navi_Master_SBID.indexOf(sbid);
				}

				if (findMasterSBID>=0)
				{
					ezentrum_session_vars.Navi_Master_SBCount[findMasterSBID]=speaSBIDCount;
					let resSPEADisplay:boolean=(speaSBIDCount>=1);
					this.log(resSPEADisplay.toString()+" - SPEA-Navigation-Hits-Replacement: NumberOfArticles="+speaSBIDCount,"");
					return resSPEADisplay;
				}
				else // Hide Entry
					return false;
			}else // Hide Entry
				return false;

		} else
		{
			
			this.log("checkDisplayStatus: ZART-Mode: active, Level="+level,"");
			
			let resSBIDZartMatchIndex = []; // ZART-SBID-Match-Index Array
			let resZARTSBCount=[]; // ZART-SBID-Match-Count Array -> Contains all ZART-SBIDs-Counts = Hits for the ZART-SBID-Articles
			let resZARTSBIDs=[]; // ZART-SBId-Match Array -> Contains all SBIds that matches to the ZART-SBID.
			let resZARTID=[]; // ZART-ID -> SBIDs for all zart-ids that match to the SBIDs
			let i = -1;

			// Find all ZART-Index-Entries for the SBID
			if ( Modules.isInShopView ) {
				while ((i = ezentrum_session_vars.Navi_ZART_SBID.indexOf(sbid, i+1)) != -1){
					resSBIDZartMatchIndex.push(i);
				}
			} else {
				while ((i = Modules.modulesVariables.Navi_ZART_SBID.indexOf(sbid, i+1)) != -1){
					resSBIDZartMatchIndex.push(i);
				}
			}

			// Loop through the SBID-ZART-Matches and fill up the ZART-Match-Arrays
			for (let i = 0; i < resSBIDZartMatchIndex.length; i++) {
				let index=resSBIDZartMatchIndex[i];

				if ( Modules.isInShopView ) {
					resZARTSBCount.push(ezentrum_session_vars.Navi_ZART_COUNT[index]);
					resZARTSBIDs.push(ezentrum_session_vars.Navi_ZART_SBID[index]);
					resZARTID.push(ezentrum_session_vars.Navi_ZART_ID[index]);
				} else {
					resZARTSBCount.push( Modules.modulesVariables.Navi_ZART_COUNT[index] );
					resZARTSBIDs.push( Modules.modulesVariables.Navi_ZART_SBID[index] );
					resZARTID.push( Modules.modulesVariables.Navi_ZART_ID[index] );
				}
				
			}

			// ZART-ID (Calculation of article-hit-numbers for ZART)
			let resZartSBID_Add:number=0;
			let resZartSBID_Minus:number=0;

			for (let i = 0; i < resZARTSBIDs.length; i++) {
				let zartSBID=resZARTID[i];
				let find;

				if ( Modules.isInShopView ) {
					find=ezentrum_session_vars.Customer_ZARTSBIDs.indexOf(zartSBID);
				} else {
					find=Modules.modulesVariables.Customer_ZARTSBIDs.indexOf(zartSBID);
				}

				if (find>=0)
					resZartSBID_Add+=resZARTSBCount[i];
				else
					resZartSBID_Minus+=resZARTSBCount[i];
			}

			this.log("Minus:"+resZartSBID_Minus+", SBID:"+sbid,"");
			this.log("Add:"+resZartSBID_Add+", SBID:"+sbid,"");

			if (resMasterSBIDIndex===-1) // Security Return true : If the SBID will nicht match,then display the entry.
				return true;

			let sbNaviHitCount:number;

			if ( Modules.isInShopView ) {
				sbNaviHitCount = ezentrum_session_vars.Navi_Master_SBCount[resMasterSBIDIndex];
			} else {
				sbNaviHitCount = Modules.modulesVariables.Navi_Master_SBCount[resMasterSBIDIndex];
			}
			if (sbNaviHitCount===0) // If the current node has no visible Arts, then use all visible number of arts from the sub-menu, to check whether the node should be displayed.
			{
				sbNaviHitCount=sumOfAllVisibleArtsInSubmenu;
			}

			let sbNaviHitCountRES:number=(sbNaviHitCount-resZartSBID_Minus)+resZartSBID_Add;
			this.log("SBID:"+sbid+", Display="+result+", NumberOfArts="+sbNaviHitCountRES,"");

			result=(sbNaviHitCountRES>0);

			return result;
		}
	}

	// Methode will return the SPEA-Mode-Status
	private isSpeaMode():boolean{
		let mandant_spea_mode:boolean;
		if ( Modules.isInShopView ) {
			mandant_spea_mode = ezentrum_session_vars.mandant_flag_spea;
		} else {
			mandant_spea_mode = Modules.modulesVariables.mandant_flag_spea;
		}
		return mandant_spea_mode;
	}


	// Method will cound all visible zart-articles for one sbid.
	// It will use the central zart-navigation cache for performance reasons.
	private countVisibleZartNumberArts(sbid:number, sumOfAllVisibleArtsInSubmenu:number):number{
		let resMasterSBIDIndex=-1;
		if ( Modules.isInShopView ) {
			resMasterSBIDIndex = ezentrum_session_vars.Navi_Master_SBID.findIndex(( entry: any ) => entry === sbid);
		} else {
			resMasterSBIDIndex = Modules.modulesVariables.Navi_Master_SBID.findIndex(( entry: any ) => entry === sbid);
		}

		let resSBIDZartMatchIndex = []; // ZART-SBID-Match-Index Array
		let resZARTSBCount=[]; // ZART-SBID-Match-Count Array -> Contains all ZART-SBIDs-Counts = Hits for the ZART-SBID-Articles
		let resZARTSBIDs=[]; // ZART-SBId-Match Array -> Contains all SBIds that matches to the ZART-SBID.
		let resZARTID=[]; // ZART-ID -> SBIDs for all zart-ids that match to the SBIDs
		let i = -1;

		// Find all ZART-Index-Entries for the SBID
		if ( Modules.isInShopView ) {
			while ((i = ezentrum_session_vars.Navi_ZART_SBID.indexOf(sbid, i+1)) != -1){
				resSBIDZartMatchIndex.push(i);
			}
		} else {
			while ((i = Modules.modulesVariables.Navi_ZART_SBID.indexOf(sbid, i+1)) != -1){
				resSBIDZartMatchIndex.push(i);
			}
		}

		// Loop through the SBID-ZART-Matches and fill up the ZART-Match-Arrays
		for (let i = 0; i < resSBIDZartMatchIndex.length; i++) {
			let index=resSBIDZartMatchIndex[i];

			if ( Modules.isInShopView ) {
				resZARTSBCount.push(ezentrum_session_vars.Navi_ZART_COUNT[index]);
				resZARTSBIDs.push(ezentrum_session_vars.Navi_ZART_SBID[index]);
				resZARTID.push(ezentrum_session_vars.Navi_ZART_ID[index]);
			} else {
				resZARTSBCount.push( Modules.modulesVariables.Navi_ZART_COUNT[index] );
				resZARTSBIDs.push( Modules.modulesVariables.Navi_ZART_SBID[index] );
				resZARTID.push( Modules.modulesVariables.Navi_ZART_ID[index] );
			}
		}

		// ZART-ID (Calculation of article-hit-numbers for ZART)
		let resZartSBID_Add:number=0;
		let resZartSBID_Minus:number=0;

		for (let i = 0; i < resZARTSBIDs.length; i++) {
			let zartSBID=resZARTID[i];
			let find:number=0;

			if ( Modules.isInShopView ) {
				find=ezentrum_session_vars.Customer_ZARTSBIDs.indexOf(zartSBID);
			} else {
				find=Modules.modulesVariables.Customer_ZARTSBIDs.indexOf(zartSBID);
			}

			if (find>=0)
				resZartSBID_Add+=resZARTSBCount[i];
			else
				resZartSBID_Minus+=resZARTSBCount[i];
		}

		this.log("Minus:"+resZartSBID_Minus+", SBID:"+sbid,"");
		this.log("Add:"+resZartSBID_Add+", SBID:"+sbid,"");

		if (resMasterSBIDIndex===-1) // Security Return true : If the SBID will not match,then display the entry.
			return 0;

		let sbNaviHitCount:number;

		if ( Modules.isInShopView ) {
			sbNaviHitCount = ezentrum_session_vars.Navi_Master_SBCount[resMasterSBIDIndex];
		} else {
			sbNaviHitCount = Modules.modulesVariables.Navi_Master_SBCount[resMasterSBIDIndex];
		}
		if (sbNaviHitCount===0) // If the current node has no visible Arts, then use all visible number of arts from the sub-menu, to check whether the node should be displayed.
		{
			sbNaviHitCount=sumOfAllVisibleArtsInSubmenu;
		}

		let sbNaviHitCountRES:number=(sbNaviHitCount-resZartSBID_Minus)+resZartSBID_Add;
		return sbNaviHitCountRES;

	}


  /**
     * @param message the log entry
     * @param outputStyle the outputStyle (css) displayed in the console
     */
    public log(message: string, outputStyle: string = ""): void {
        Logging.GENERAL_LOG.add(message, outputStyle, false);
    }

}